package com.alpha.showcase.common.cache

import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class SourceCacheDatabase_AutoMigration_1_2_Impl : Migration {
  public constructor() : super(1, 2)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("CREATE TABLE IF NOT EXISTS `gallery_source_media` (`id` INTEGER PRIMARY KEY AUTOINCREMENT NOT NULL, `source_name` TEXT NOT NULL, `media_uri` TEXT NOT NULL, `display_name` TEXT NOT NULL, `mime_type` TEXT NOT NULL, `added_at` INTEGER NOT NULL)")
    connection.execSQL("CREATE INDEX IF NOT EXISTS `index_gallery_source_media_source_name` ON `gallery_source_media` (`source_name`)")
    connection.execSQL("CREATE INDEX IF NOT EXISTS `index_gallery_source_media_added_at` ON `gallery_source_media` (`added_at`)")
    connection.execSQL("CREATE UNIQUE INDEX IF NOT EXISTS `index_gallery_source_media_source_name_media_uri` ON `gallery_source_media` (`source_name`, `media_uri`)")
  }
}
